export function useNpmData() {
  const installationInstructionsNpm = `npm install @cognitivecloud/actions`;
  const installationInstructionsYarn = `yarn add @cognitivecloud/actions`;

  const initializationInstructions = `import { ActionsAPI } from "@cognitivecloud/actions";
const API_KEY = process.env.COGNITIVE_CLOUD_API_KEY;

const client = new ActionsAPI(API_KEY);`;

  const searchActionsInstructions = ({
    variables,
  }) => `import { ActionFilter } from "@cognitivecloud/actions";
const filters = new ActionFilter(${JSON.stringify(variables, null, 2)});
const actions = await client.searchActions(filters);
console.log("SEARCH RESULTS:", actions);
`;

  const getActionInstructions = ({
    actionId,
  }) => `const actionId = "${actionId}";
const action = await client.getAction(actionId);
console.log("GET ACTION:", action);
`;

  const runJobInstructions = ({ actionId, payload }) => {
    return `const actionId = "${actionId}";
const payload = ${payload};

// Return the job details BEFORE the job is completed, after the job is created
const job = await client.runActionJob(actionId, payload);
console.log("JOB DETAILS:", job);

// OR

// Return the job details AFTER the job is completed
const completedJob = await client.runActionJob(actionId, payload, { waitForResponse: true });
console.log("COMPLETED JOB DETAILS:", completedJob);`;
  };

  const getJobInstructions = ({ jobId }) => {
    return `const jobId = "${jobId}"
const jobDetails = await client.getJob(jobId);`;
  };

  const npmInstructions = {
    getaction: getActionInstructions,
    list_actions: searchActionsInstructions,
    runjob: runJobInstructions,
    get_job: getJobInstructions,
  };

  const getQueryInstructions = (query, variables) => {
    const queryName = query?.definitions[0]?.name?.value?.toLowerCase().trim();
    if (!queryName) return;

    const npmInstruction = npmInstructions[queryName];
    if (!npmInstruction) return;

    const { actionId, payload, jobId } = variables;
    const configuredNpmInstruction = npmInstruction({
      actionId,
      payload,
      jobId,
      variables,
    });

    return configuredNpmInstruction;
  };

  const hasNpmInstructions = (query) => {
    if (!query) return false;
    const queryName = query?.definitions[0]?.name?.value?.toLowerCase().trim();
    if (!queryName) return false;
    return !!npmInstructions[queryName];
  };

  const getQueryTitle = (query) => {
    const queryName = query?.definitions[0]?.name?.value?.trim();
    if (!queryName) return '';
    const title = queryName.replace(/_/g, ' ');
    return title;
  };

  return {
    installationInstructionsNpm,
    installationInstructionsYarn,
    initializationInstructions,
    getQueryInstructions,
    getQueryTitle,
    hasNpmInstructions,
  };
}
